import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import SetUserFlagMutation from './SetUserFlagMutation';
import FetchUserFlagQuery from '../FetchUserFlag/FetchUserFlagQuery';
import { UserFlagIdentifierType } from '../types';

interface ISetUserFlagConnectorApollo {
  children: (result: any) => JSX.Element;
}

const SetUserFlagConnectorApollo: React.FC<ISetUserFlagConnectorApollo> = ({ children }) => {
  const [setUserFlag, { data, loading }] = useMutation(SetUserFlagMutation);

  const createSetUserFlag = async (identifier: UserFlagIdentifierType) => {
    const response = await setUserFlag({
      variables: { identifier: identifier },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: FetchUserFlagQuery,
          variables: { identifier: identifier },
        },
      ],
    });

    return response;
  };

  return children({
    setUserFlagData: {
      setUserFlag: createSetUserFlag,
      response: data,
      loading,
    },
  });
};

SetUserFlagConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default SetUserFlagConnectorApollo;
